import { useCallback } from 'react';
import { generatePath } from 'react-router-dom';

type PostWithPath = { path: string };

export const usePostPath = (basePath: string): ((post: PostWithPath) => string) => {
  return useCallback(
    (post: PostWithPath) => {
      return generatePath(':basePath/:postPath', {
        basePath: basePath,
        postPath: post.path,
      });
    },
    [basePath]
  );
};
